import React from "react";
import { Box, Grid, Typography, Card, CardMedia } from "@mui/material";

import ajax from "../../../assets/nw/ajax-engineering-pvt-ltd-logo-vector.png";
import everblue from "../../../assets/nw/everblue-piscines-logo-vector.png";
import gannon from "../../../assets/nw/download-1.png";
import keihin from "../../../assets/nw/2560px-Keihin_company_logo.svg_-1536x352.png";
import raymond from "../../../assets/nw/Raymond_logo.svg_.png";
import arrow from "../../../assets/nw/1008-arrow-1.jpg";
import bluestar from "../../../assets/nw/download-2.png";
import larsen from "../../../assets/nw/logo.webp";

const industryLogos = [
  { id: 1, image: ajax, name: "AJAX" },
  { id: 2, image: everblue, name: "Everblue Piscines" },
  { id: 3, image: gannon, name: "Gannon Dunkerley & Co. Ltd." },
  { id: 4, image: keihin, name: "Keihin" },
  { id: 5, image: raymond, name: "Raymond" },
  { id: 6, image: arrow, name: "Arrow" },
  { id: 7, image: bluestar, name: "Blue Star" },
  { id: 8, image: larsen, name: "Larsen & Toubro" },
];

const KiadbIndustrialArea = () => {
  return (
    <Box sx={{ backgroundColor: "#f8f8f8", py: 10 }}>
      <Box sx={{ maxWidth: "1200px", mx: "auto", textAlign: "center", px: 2 }}>
        {/* Heading */}
        <Typography
          variant="h4"
          sx={{
            fontWeight: 800,
            color: "#006769",
            mb: 1,
            textTransform: "uppercase",
            letterSpacing: "1px",
          }}
        >
          KIADB INDUSTRIAL AREA
        </Typography>

        {/* Description */}
        <Typography
          variant="body1"
          sx={{
            color: "#555",
            fontSize: "18px",
            maxWidth: "800px",
            mx: "auto",
            mb: 6,
            lineHeight: "30px",
          }}
        >
          Leading Industries Situated In Karnataka Industrial Area Development
          Board
        </Typography>

        {/* Industry Logos Grid */}
        <Grid container spacing={4} justifyContent="center">
          {industryLogos.map((industry) => (
            <Grid
              item
              key={industry.id}
              xs={12}
              sm={6}
              md={4}
              lg={3}
              sx={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Card
                sx={{
                  width: "100%",
                  maxWidth: 260,
                  height: 150,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#f1f1f1",
                  borderRadius: "12px",
                  boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    transform: "translateY(-6px)",
                    boxShadow: "0 6px 25px rgba(0,0,0,0.15)",
                    backgroundColor: "#ffffff",
                  },
                }}
              >
                <CardMedia
                  component="img"
                  image={industry.image}
                  alt={industry.name}
                  sx={{
                    width: "120px",
                    height: "auto",
                    objectFit: "contain",
                    opacity: 0.9,
                    transition: "opacity 0.3s ease",
                    "&:hover": { opacity: 1 },
                  }}
                />
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default KiadbIndustrialArea;
